import React from 'react';
import styled from '@emotion/styled';
import { Contact } from './types';
import { UnstyledLink } from '../Common/Primitives';

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ContactItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border: 1px solid #eee;
  border-radius: 4px;
  background-color: white;

  &:hover {
    background-color: #f9f9f9;
  }
`;

const ContactName = styled.span`
  font-weight: 500;
  color: #333;
`;

const ContactBirthday = styled.span`
  font-size: 0.9em;
  color: #666;
`;

interface Props {
  contacts: Contact[];
}

// Helper to format "YYYY-MM-DD" to readable "DD MMM" (e.g., "15 Jan")
const formatBirthday = (dateStr?: string) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString(undefined, { day: 'numeric', month: 'short' });
};

export const ContactsBirthdaysNotice = ({ contacts }: Props) => {
  if (!contacts || contacts.length === 0) {
    return null;
  }

  return (
    <ListWrapper>
      {contacts.map(contact => (
        <UnstyledLink 
          key={contact._id} 
          to={`/contacts?show=${contact.name}`}
        >
          <ContactItem>
            <ContactName>{contact.name}</ContactName>
            <ContactBirthday>
              {formatBirthday(contact.birth_date)}
            </ContactBirthday>
          </ContactItem>
        </UnstyledLink>
      ))}
    </ListWrapper>
  );
};

